import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M18.25 7.75c0 .828-3.28 1.5-8.25 1.5-4.97 0-8.25-.672-8.25-1.5m16.5 4.5c0 .828-3.28 1.5-8.25 1.5-4.97 0-8.25-.672-8.25-1.5m16.5 4.5c0 .828-3.28 1.5-8.25 1.5-4.97 0-8.25-.672-8.25-1.5m0-13.25v13m16.5-13v13m0-13.25c0 .828-3.28 1.5-8.25 1.5-4.97 0-8.25-.672-8.25-1.5s3.28-1.5 8.25-1.5c4.97 0 8.25.672 8.25 1.5Z"
	})]
});
const ForwardRef = forwardRef(SvgDatabase);
export { ForwardRef as ReactComponent };
